import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Layout from './Default/Layout';
import { useStateValue } from "./GlobalState/StateProvider";
import AppRoutes from './AppRoutes';
import AppRoutesLogin from './AppRoutesLogin';
import { jwtDecode } from 'jwt-decode';

// PrimeReact styles
import 'primereact/resources/themes/nano/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

function App() {
    const [{ user }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true); // NEW: Prevents flickering issue

    // This function checks if the token is expired and handles logout
    const checkTokenExpiration = () => {
        const storedUser = JSON.parse(localStorage.getItem('CoderFromMars_User'));

        if (storedUser?.token) {
            try {
                const decoded = jwtDecode(storedUser.token);
                const now = Date.now() / 1000;

                if (decoded?.exp < now) {
                    // Token expired - clear everything
                    localStorage.removeItem('CoderFromMars_User');
                    // Clear the user from context state too
                    dispatch({ 
                        type: 'ADD_USER', 
                        item: { user_id: null, userName: null, email: null, admin: null, token: null, created: null } 
                    });
                    navigate('/');
                    return false;
                } else {
                    // Valid token - update the user state
                    dispatch({ type: 'ADD_USER', item: storedUser });
                    //navigate('/Dashboard');
                    return true;
                }
            } catch (error) {
                console.error("Token decode error:", error);
                // Invalid token format - clear everything
                localStorage.removeItem('CoderFromMars_User');
                dispatch({ 
                    type: 'ADD_USER', 
                    item: { user_id: null, userName: null, email: null, admin: null, token: null, created: null } 
                });
                navigate('/');
                return false;
            }
        }
        return false;
    };

    // Initial token check on app load
    useEffect(() => {
        checkTokenExpiration();
        setLoading(false);
    }, []);

    // Set up a periodic token check (every minute)
    useEffect(() => {
        const intervalId = setInterval(() => {
            checkTokenExpiration();
        }, 60000); // Check every minute
        
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    if (loading) return <div>Loading...</div>; // Prevents flickering by waiting until authentication is checked

    return (
        <div>
            {user?.token ? (
                <Layout>
                    <Routes>
                        {AppRoutes.map((route, index) => (
                            <Route key={index} {...route} />
                        ))}
                    </Routes>
                </Layout>
            ) : (
                <Routes>
                    {AppRoutesLogin.map((route, index) => (
                        <Route key={index} {...route} />
                    ))}
                </Routes>
            )}
        </div>
    );
}

export default App;





















//import React, { useEffect, useState } from 'react';
//import { Route } from 'react-router';
//import { useNavigate, useParams, Routes } from 'react-router-dom';
//import Layout from './Default/Layout';
//import { useStateValue }  from "./GlobalState/StateProvider";
//import { useApiHook } from './Helper/ApiHook/apiHook';
//import axios from "axios";
//import AppRoutes from './AppRoutes';
//import AppRoutesLogin from './AppRoutesLogin';
//import { jwtDecode } from 'jwt-decode';
//import 'primereact/resources/themes/nano/theme.css';
//import 'primereact/resources/primereact.min.css';
//import 'primeicons/primeicons.css';
//import 'primeflex/primeflex.css';


//function App() {
   
//    const [{ user }, dispatch] = useStateValue();
//    const navigate = useNavigate();
   

//    const checkStoredToken = (user_, storageName) => {

//        if (user_ !== null) {

//            var userToken = user_.token;
//            var decoded = jwtDecode(userToken);

//            const now = Date.now().valueOf() / 1000

//            if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {

//                localStorage.removeItem(storageName);
//                navigate('/');


//            } else {
//                dispatch({
//                    type: 'ADD_USER',
//                    item: user_
//                });

//                navigate('/Dashboard');



//            }
//        }
//        else {
//            // do something
//        }

//    }

//    useEffect(() => {
//        if (!user.token) {

//            var user_ = JSON.parse(localStorage.getItem('CoderFromMars_User'));
//            checkStoredToken(user_, 'CoderFromMars_User');

//        }
//        else {
//            navigate('/Dashboard');

//        }


//    }, [user.token]);
  

  

//    return (


       
//            <div>
//                {
//                    !user.token ?
//                        <div>
//                            <Routes>
//                                    {AppRoutesLogin.map((route, index) => {
//                                        const { element, ...rest } = route;
//                                        return <Route key={index} {...rest} element={element} />;
//                                    })}
//                                </Routes>
//                        </div>
//                        :
//                        <div>
//                             <Layout>
//                                <Routes>
//                                    {AppRoutes.map((route, index) => {
//                                        const { element, ...rest } = route;
//                                        return <Route key={index} {...rest} element={element} />;
//                                    })}
//                                </Routes>
//                            </Layout>
//                        </div>


//                }
//            </div>
           
//    );

//}
//export default App;